"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _reactComponents = require("@ui-propulsion/react-components");
var _lcHttp = _interopRequireDefault(require("lc-http"));
var _index = require("../../utils/index");
var _ = require("..");
require("./styles.scss");
var _constants = require("../../utils/constants");
var _excluded = ["ref"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var RefundInstructionForm = function RefundInstructionForm(_ref) {
  var disbursedAmount = _ref.disbursedAmount,
    feeRate = _ref.feeRate,
    isAgent = _ref.isAgent,
    contacts = _ref.contacts,
    previousRefundsTotal = _ref.previousRefundsTotal,
    applicationId = _ref.applicationId,
    clientId = _ref.clientId,
    actionsUrls = _ref.actionsUrls,
    draftRefund = _ref.draftRefund,
    setRefundStatus = _ref.setRefundStatus,
    setSubmittedData = _ref.setSubmittedData,
    setInProgress = _ref.setInProgress,
    goToDashboard = _ref.goToDashboard,
    netPracticeFee = _ref.netPracticeFee;
  var creditRemaining = (0, _index.toFixedPrecisionTwo)(disbursedAmount - previousRefundsTotal);
  var _useForm = (0, _reactHookForm.useForm)({
      mode: 'onBlur',
      defaultValues: {
        applicationId: applicationId,
        clientId: clientId,
        authorizedByProvider: false,
        adminFee: '',
        adminFeeRate: feeRate * 100,
        refundAmount: '',
        refundMethod: 'ACH',
        // These are not allowed in the post method and should be removed before submitting
        netRefund: '',
        totalCharges: '',
        fullRefund: creditRemaining === (draftRefund === null || draftRefund === void 0 ? void 0 : draftRefund.refundAmount)
      }
    }),
    register = _useForm.register,
    control = _useForm.control,
    formState = _useForm.formState,
    watch = _useForm.watch,
    handleSubmit = _useForm.handleSubmit,
    setValue = _useForm.setValue,
    getValues = _useForm.getValues,
    clearErrors = _useForm.clearErrors,
    setError = _useForm.setError;
  var fullRefund = watch('fullRefund');
  var totalCharges = watch('totalCharges');
  var netRefund = watch('netRefund');
  var refundAmount = watch('refundAmount');
  var adminFee = watch('adminFee');
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    refundAction = _useState2[0],
    setRefundAction = _useState2[1];
  var _useState3 = (0, _react.useState)(!draftRefund),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    initialNewRefund = _useState4[0],
    setInitialNewRefund = _useState4[1];
  var exceedsCreditRemaining = function exceedsCreditRemaining(v) {
    var cred = parseFloat(creditRemaining);
    var val = parseFloat(v);
    // Don't allow refund amount less than $1
    if (!fullRefund && (val < 1 || val > cred - 1)) {
      return "Please enter an amount lower than ".concat((0, _index.toDollar)(creditRemaining - 1));
    }
    return true;
  };
  var totalAmountRules = function totalAmountRules() {
    return {
      required: {
        value: true,
        message: 'This field is required'
      },
      validate: {
        exceedsCreditRemaining: exceedsCreditRemaining
      }
    };
  };
  var adminFeeProps = register('adminFee');
  var setErrorOnTotalCharges = function setErrorOnTotalCharges(errorMessage) {
    setError('totalCharges', {
      type: 'custom',
      message: errorMessage
    }, {
      shouldFocus: true
    });
    setValue('refundAmount', '');
    setValue('adminFee', '');
    setValue('netRefund', '');
  };
  var calculateValues = (0, _react.useCallback)((0, _lodash.default)(function (value) {
    var val = parseFloat(value);
    if (!fullRefund && (val < 1 || val > parseFloat(creditRemaining) - 1)) {
      setErrorOnTotalCharges("Please enter an amount lower than ".concat((0, _index.toDollar)(creditRemaining - 1)));
      return;
    }
    var payload = {
      applicationId: applicationId,
      clientId: clientId,
      totalCharges: value === '' ? 0 : value
    };
    _lcHttp.default.post('refunds/calculateRefund', payload).then(function (_ref2) {
      var data = _ref2.data;
      clearErrors();
      setValue('refundAmount', data.refundAmount);
      setValue('adminFee', data.adminFee);
      setValue('netRefund', data.debitFromProvider);
    }).catch(function (error) {
      console.log('error', error);
      setErrorOnTotalCharges('An error occurred while calculating the refund amount. Please try again later.');
    });
  }, 1000), [fullRefund]);
  var updateRefundNumbers = function updateRefundNumbers() {
    if (totalCharges === 0 && creditRemaining === disbursedAmount) {
      // PF-28597: Use disbursedAmount and netPracticeFee from API for a flat cancel
      setValue('refundAmount', disbursedAmount);
      setValue('adminFee', netPracticeFee);
      setValue('netRefund', disbursedAmount - netPracticeFee);
    } else {
      calculateValues(totalCharges);
    }
  };
  (0, _react.useEffect)(function () {
    if (draftRefund && !fullRefund) {
      setValue('totalCharges', (0, _index.toFixedPrecisionTwo)(creditRemaining - draftRefund.refundAmount), {
        shouldValidate: false
      });
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (fullRefund) {
      setValue('totalCharges', 0, {
        shouldValidate: true
      });
    }
  }, [fullRefund]);
  (0, _react.useEffect)(function () {
    if (initialNewRefund) {
      setInitialNewRefund(false);
    } else if (totalCharges !== '') {
      updateRefundNumbers(totalCharges);
    }
  }, [totalCharges]);
  var handleSuccess = function handleSuccess(response) {
    setInProgress(false);
    setRefundStatus(_constants.refundSubmittedStatus);
    return response;
  };
  var handleError = function handleError() {
    setInProgress(false);
    setRefundStatus(_constants.refundErrorStatus);
  };
  var onValidSubmit = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
      var isDelete, _formUtils$configRequ, method, url;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            isDelete = refundAction === 'delete';
            setInProgress(true);
            setSubmittedData((0, _defineProperty2.default)({
              dateProcessed: new Date().toISOString(),
              netRefund: data.netRefund,
              refundAmount: data.refundAmount
            }, refundAction, true));
            /*
             *  For new refunds use POST
             *  For saved/drafted use PATCH
             *  For refundAction === delete use DELETE
             */
            _formUtils$configRequ = _index.formUtils.configRequest({
              isDelete: isDelete,
              inProcess: !!draftRefund,
              actionsUrls: actionsUrls
            }), method = _formUtils$configRequ.method, url = _formUtils$configRequ.url;
            _lcHttp.default[method](url, {
              data: _index.formUtils.prepareFormData(data, refundAction)
            }).then(handleSuccess).catch(handleError);
            _context.next = 14;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            setInProgress(false);
            setSubmittedData(null);
            setRefundStatus(_constants.refundErrorStatus);
            return _context.abrupt("return", _context.t0);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function onValidSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onInvalidSubmit = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(err) {
      var notRequiredForSave, shouldPost;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            notRequiredForSave = ['authorizedByProvider'];
            if (!(refundAction === 'save')) {
              _context2.next = 8;
              break;
            }
            clearErrors(notRequiredForSave);
            shouldPost = true;
            Object.keys(err).forEach(function (key) {
              if (!notRequiredForSave.includes(key)) {
                shouldPost = false;
              }
            });
            if (!shouldPost) {
              _context2.next = 8;
              break;
            }
            _context2.next = 8;
            return onValidSubmit(getValues());
          case 8:
            if (!(refundAction === 'delete')) {
              _context2.next = 12;
              break;
            }
            clearErrors();
            _context2.next = 12;
            return onValidSubmit(getValues());
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onInvalidSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var requiredForProviderMessage = 'This is a required field';
  var errors = formState.errors;
  var totalAmountServiceError = errors.totalCharges && errors.totalCharges.message;
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "refund__section-title"
  }, "REFUND INFORMATION"), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "required-note"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "required-indicator"
  }, "*"), "Required fields", ' ')), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit(onValidSubmit, onInvalidSubmit)
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    spacing: 2,
    className: "refund-reason__fieldset"
  }, draftRefund && /*#__PURE__*/_react.default.createElement("input", Object.assign({
    className: "hidden"
  }, register('refundId'), {
    value: draftRefund.refundId
  })), contacts.length > 0 && /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_.SelectInputControlled, {
    control: control,
    name: "refundContactId",
    options: contacts,
    placeholder: "Refund authorized by",
    isRequired: true
  })), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_.CheckboxControlled, {
    centered: true,
    control: control,
    name: "fullRefund",
    labelText: "Check this box for a <b>full refund</b>"
  })), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    rules: totalAmountRules(),
    control: control,
    name: "totalCharges",
    render: function render(_ref5) {
      var _ref5$field = _ref5.field,
        ref = _ref5$field.ref,
        rest = (0, _objectWithoutProperties2.default)(_ref5$field, _excluded);
      return /*#__PURE__*/_react.default.createElement(_.DollarAmount, Object.assign({
        boldText: true,
        label: "Total Charges for Services",
        isRequired: true,
        errorMsg: totalAmountServiceError,
        isFieldDisabled: !!fullRefund
      }, rest, {
        type: "tel",
        inputMode: "decimal",
        onChange: function onChange(e) {
          var value = (0, _index.sanitizeValues)(e.target.value, _index.REGEX_DIGITS_AMOUNT);
          rest.onChange(value);
        }
      }));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_.DollarAmount, {
    name: "refundAmtDue",
    value: refundAmount,
    label: "Refund Due to Borrower",
    isFieldDisabled: true
  })), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_.DollarAmount, {
    label: "Less Fee",
    name: adminFeeProps.name,
    onChange: adminFeeProps.onChange,
    onBlur: adminFeeProps.onBlur,
    value: adminFee,
    isFieldDisabled: true
  }))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    className: "refund-net__section"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "refund-net__label"
  }, "Debit from Provider")), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    container: true,
    xs: 6,
    justifyContent: "flex-end",
    className: "refund-net__amount-wrapper"
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "refund-net__label--strong",
    "data-testid": "debit-from-provider"
  }, (0, _index.toDollar)(netRefund)))), isAgent && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    direction: "row",
    alignContent: "center"
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "refund-method__title"
  }, "Refund Method")), /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    control: control,
    name: "refundMethod",
    render: function render(_ref6) {
      var field = _ref6.field;
      return /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
        container: true,
        direction: "row",
        alignContent: "center"
      }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
        item: true,
        container: true,
        xs: 6,
        md: 2
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "refund-method__section",
        htmlFor: "input-field-ACH"
      }, /*#__PURE__*/_react.default.createElement("input", Object.assign({
        id: "input-field-ACH",
        "aria-labelledby": "radio-label-ACH",
        type: "radio"
      }, field, {
        checked: (field === null || field === void 0 ? void 0 : field.value) === 'ACH',
        value: "ACH",
        "data-test-id": "ACH"
      })), /*#__PURE__*/_react.default.createElement("div", {
        id: "radio-label-ACH",
        className: "radio-label"
      }, ' ', "ACH", ' '))), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
        item: true,
        container: true,
        xs: 6,
        md: 2
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "refund-method__section",
        htmlFor: "field-input-Check"
      }, /*#__PURE__*/_react.default.createElement("input", Object.assign({
        id: "field-input-Check",
        "aria-labelledby": "radio-label-Check",
        type: "radio"
      }, field, {
        checked: (field === null || field === void 0 ? void 0 : field.value) === 'CHECK',
        value: "CHECK",
        "data-test-id": "Check"
      })), /*#__PURE__*/_react.default.createElement("div", {
        id: "radio-label-Check",
        className: "radio-label"
      }, ' ', "Check", ' '))), field.value === 'CHECK' && /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
        container: true,
        className: "check-number-field__wrapper",
        direction: "row",
        alignContent: "center"
      }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
        item: true,
        xs: 2
      }), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
        item: true,
        xs: 10
      }, /*#__PURE__*/_react.default.createElement(_.CheckNumberField, {
        control: control
      }))));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_.CheckboxControlled, {
    isRequired: true,
    errorMessage: isAgent ? "".concat(requiredForProviderMessage, " for only processing this refund request but is not a requirement for saving this refund request") : requiredForProviderMessage,
    control: control,
    name: "authorizedByProvider",
    labelText: "I have authorized to process this transaction for <b>".concat((0, _index.toDollar)(netRefund), "</b>. By authorizing this transaction, an ACH debit will be completed within 24 business hours.<i class=\"required-indicator\">*</i>")
  })), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    className: "refund-button-section",
    direction: "column",
    container: true
  }, /*#__PURE__*/_react.default.createElement(_.ButtonSection, {
    isDraft: !!draftRefund,
    isAgent: isAgent,
    setRefundAction: setRefundAction,
    control: control,
    goToDashboard: goToDashboard
  })))));
};
RefundInstructionForm.defaultProps = {
  contacts: [],
  draftRefund: null
};
RefundInstructionForm.propTypes = {
  actionsUrls: (0, _propTypes.shape)({
    post: (0, _propTypes.shape)({}).isRequired,
    patch: (0, _propTypes.shape)({}).isRequired,
    delete: (0, _propTypes.shape)({}).isRequired
  }).isRequired,
  previousRefundsTotal: _propTypes.number.isRequired,
  feeRate: _propTypes.number.isRequired,
  isAgent: _propTypes.bool.isRequired,
  disbursedAmount: _propTypes.string.isRequired,
  clientId: _propTypes.number.isRequired,
  applicationId: _propTypes.number.isRequired,
  draftRefund: (0, _propTypes.shape)({
    applicationId: _propTypes.number.isRequired,
    clientId: _propTypes.number.isRequired,
    refundId: _propTypes.number.isRequired,
    dateProcessed: _propTypes.string,
    refundAmount: _propTypes.string.isRequired
  }),
  contacts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string.isRequired,
    id: _propTypes.number.isRequired,
    value: _propTypes.number.isRequired
  })),
  setRefundStatus: _propTypes.func.isRequired,
  setSubmittedData: _propTypes.func.isRequired,
  setInProgress: _propTypes.func.isRequired,
  goToDashboard: _propTypes.func.isRequired,
  netPracticeFee: _propTypes.string.isRequired
};
var _default = exports.default = RefundInstructionForm;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/RefundInstructionForm/styles.scss');